import Main from '@components/Main'
import localMerchant from './localMerchant'
import Error from '@components/Error'
import CashierJava from '@components/CashierJava'
import Cashier from '@components/CashierOutside'
import { asyncLoad } from '@util'
import { ACCOUNT_MANAGE_PATH } from '@constant'
import SupportCenter from '@components/SupportCenter'
import supportRoutes from './supportCenter'

export const otherRoutes = [
  {
    path: 'cashierNew',
    component: CashierJava
  },
  {
    path: 'annualMerchantShow',
    component: asyncLoad(() =>
      import('@components/ActivityPage/AnnualMerchantShow')
    )
  },
  {
    path: '*',
    component: Error
  }
]

export const NeedAuthRoutes = [
  {
    path: 'cashier',
    component: Cashier
  },
  {
    path: '*',
    component: Error
  }
]

export default [
  {
    path: '/',
    component: Main,
    indexRoute: {
      onEnter(ns, replace) {
        replace('/localMerchant')
      }
    },
    childRoutes: [
      localMerchant,

      /**
       * TODO，待去掉。这个路由用于兼容可能遗留的原来 store 开头的路由, 统一跳转到账号管理页面
       */
      {
        path: 'store*',
        indexRoute: {
          onEnter(ns, replace) {
            replace(ACCOUNT_MANAGE_PATH)
          }
        }
      }
    ]
  },
  {
    path: 'supportCenter',
    component: SupportCenter,
    indexRoute: {
      onEnter(ns, replace) {
        replace('/supportCenter/home')
      }
    },
    childRoutes: [...supportRoutes]
  },
  {
    path: 'cashier',
    component: Cashier,
    stat: '收银台'
  },
  {
    path: 'certificateStore',
    component: asyncLoad(() => import('@components/CertificateStore'))
  },
  {
    path: '*',
    component: Error
  }
]
